import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const fetchDashboardStats = async () => {
  const response = await axiosInstance.get("admin/dashboard/main-stat", {
    headers,
  });
  return response.data;
};

export const fetchDashboardPaymentStats = async (type) => {
  const response = await axiosInstance.get(
    `admin/dashboard/payment-stat?type=${type}`,
    {
      headers,
    }
  );
  return response.data;
};

export const fetchDashboardRevenueStats = async (type) => {
  const response = await axiosInstance.get(
    `admin/dashboard/revenue-stat?type=${type}`,
    {
      headers,
    }
  );
  return response.data;
};
